import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app-module';
import { installOverlayZoomFix } from './app/utils/overlay-zoom-install';

// import { Buffer } from 'buffer';
import * as process from 'process';

installOverlayZoomFix();

// Patching de l'objet global window pour simuler Node.js
(window as any).global = window;
// (window as any).Buffer = Buffer;
(window as any).process = process;

platformBrowser().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true,
})
  .catch(err => console.error(err));

